define('modules/ptera/ptera-responsive-image',[
	'app',
	'jquery-private',
	'backbone',
	'underscore',
],
function(app, $, Backbone, _) {

	return Backbone.View.extend({
		el: '.js-ptera-responsive-image',
		$el: $(this.el),
		firstRun: true,

		initialize: function(params){
			// var breakpoints = app.breakpoints;
			_.bindAll(this, 'addListeners', 'detectImages', 'updateURL');

			var detectImages = this.detectImages;

			$(window).on('views_load_more', function(e) {
				detectImages($('.js-ptera-responsive-image'));
			});

			this.detectImages();
		},

		addListeners: function() {
			var detectImages = this.detectImages;
			if (app.IEVersion !== 8) {
				$(window).on('resize', function(){
					detectImages();
				});
			}
			if (app.IEVersion == 8) {
				$(window).on('load', function() {
					detectImages();
				});
			}
		},

		detectImages: function(elements) {
			if (elements) {
				this.$el = elements;
			}
			if (this.$el.length > 1) {
				_.each(this.$el, function(item, index) {
					this.updateURL($(item));
				}, this);
			} else {
				this.updateURL(this.$el);
			}
		},

		updateURL: function(image) {

			var mobiURL = image.attr('ptera-src-xs'); // TODO: allow configurable params
			var tabletURL = image.attr('ptera-src-sm'); // TODO: allow configurable params
			var desktopURL = image.attr('ptera-src-md'); // TODO: allow configurable params

			var imageSource = desktopURL;

			if (app.isMobile(1024)) { // TODO: add in dynamic breakpoints
				imageSource = tabletURL;

				if (app.isMobile(768)) { // TODO: add in dynamic breakpoints
					imageSource = mobiURL;
				}
			}

			if (this.firstRun) {
				this.firstRun = false;
				this.addListeners();
			}

			image.attr('src', imageSource);
		}
	});

});

